module.exports = __webpack_public_path__ + "static/media/ssg13.66b51bbc.png";